/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Forward_Three_SecondsInputs */



/**
* | output |
* | --- |
* | "Go forward three second in the video" |
*
* @param {Shortcut_Keys_Desc_Forward_Three_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_forward_three_seconds = /** @type {((inputs?: Shortcut_Keys_Desc_Forward_Three_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Forward_Three_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancer de trois secondes dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spule im Video drei Sekunden vor.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai avanti di tre secondi nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перемотайте видео на три секунды вперед.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzar tres segundos en el vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频快进三秒。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画を3秒進めます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में तीन सेकंड आगे बढ़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avance três segundos no vídeo.")
	return /** @type {LocalizedString} */ ("Go forward three second in the video")
});